var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21ZM11.3319 16.7732V9.08205H9.40202V16.7732H11.3319ZM11.143 5.83816C10.9295 5.67939 10.6749 5.6 10.3793 5.6C10.0727 5.6 9.81264 5.67939 9.59912 5.83816C9.39107 5.99693 9.28705 6.27068 9.28705 6.6594C9.28705 7.04264 9.39107 7.31639 9.59912 7.48063C9.81264 7.63941 10.0727 7.71879 10.3793 7.71879C10.6749 7.71879 10.9295 7.63941 11.143 7.48063C11.362 7.31639 11.4715 7.04264 11.4715 6.6594C11.4715 6.27068 11.362 5.99693 11.143 5.83816Z",
    fill: "#B51511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconRed);
export default __webpack_public_path__ + "static/media/infoIconRed.245d572f84555a77657b2f11367a8af6.svg";
export { ForwardRef as ReactComponent };